// @flow

import * as React from 'react';
import {useIntl} from 'react-intl';
import {Dialog, DialogContent, DialogHeader} from 'sail/Dialog';
import {Title} from 'sail/Text';
import ModalLayer from 'sail/ModalLayer';
import CluiButtonLink from '../ButtonLink';
import FeedbackIcon from './FeedbackIcon';
import messages from './messages';
import {
  DEV_TOOLS,
  DeveloperToolsCsat,
} from '../../../DeveloperToolsCsat/DeveloperToolsCsat';

import './FeedbackAction.scss';

export const FeedbackAction = (): React.Node => {
  const {formatMessage} = useIntl();

  const [isVisible, setVisible] = React.useState(false);

  return (
    <>
      <CluiButtonLink
        label={<FeedbackIcon />}
        tip={formatMessage(messages.feedbackToolTip)}
        onClick={() => setVisible(true)}
      />
      <ModalLayer
        shown={isVisible}
        onWashClick={() => setVisible(false)}
        onEscape={() => setVisible(false)}
      >
        <Dialog width="645px">
          <DialogHeader
            title={<Title>{formatMessage(messages.feedbackTitle)}</Title>}
            closeLabel={formatMessage(messages.feedbackClose)}
            onClose={() => setVisible(false)}
          />
          <DialogContent padding={20}>
            <DeveloperToolsCsat
              devTool={DEV_TOOLS.STRIPE_SHELL}
              onClose={() => setVisible(false)}
            />
          </DialogContent>
        </Dialog>
      </ModalLayer>
    </>
  );
};

export default FeedbackAction;
